import React, { FC, useEffect, useState } from 'react';
import { Box, Switch, TextField, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CloseIcon from '@material-ui/icons/Close';
import {
  setOtherLandingData,
  setTicketsBundles,
} from '../../../redux/actions/propertyActions';
import dataProvider from '../../../providers/dataProvider';

interface TicketsBoundlesProps {
  pageType: string;
}

export const LandingTicketsBoundles: FC<TicketsBoundlesProps> = ({
  pageType,
}) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    ticketsBundles: Array<number>(),
  });

  const getGeneral = async () => {
    const result = await dataProvider.getLandingGeneral(pageType);
    dispatch(
      setOtherLandingData({
        name: result.data.name,
        landingType: result.data.landingType,
        ticketsBundles: result.data.ticketsBundles,
      })
    );
    if (result.data.ticketsBundles.length < 2) {
      const defaultArr = [2, 5];
      setState({ ticketsBundles: defaultArr });
      dispatch(setOtherLandingData({ ticketsBundles: defaultArr }));
    } else {
      setState({ ticketsBundles: result.data.ticketsBundles });
    }
  };

  useEffect(() => {
    getGeneral();
  }, []);

  // useEffect(() => {
  //   if (ticketsBundles.length < 2) {
  //     const defaultArr = [2, 5];
  //     setState({ ticketsBundles: defaultArr });
  //     dispatch(setOtherLandingData({ ticketsBundles: defaultArr }));
  //   } else {
  //     setState({ ticketsBundles });
  //   }
  // }, [ticketsBundles]);

  const addItem = () => {
    const ticketsAmount =
      state.ticketsBundles[state.ticketsBundles.length - 1] + 5;
    const ticketsBundlesArrCopy = [...state.ticketsBundles];
    const item = ticketsAmount;
    ticketsBundlesArrCopy.push(item);
    dispatch(setOtherLandingData({ ticketsBundles: ticketsBundlesArrCopy }));
    setState((state) => ({
      ...state,
      ticketsBundles: ticketsBundlesArrCopy,
    }));
  };

  const handleDeleteItem = (index: number) => () => {
    let copyArr = [...state.ticketsBundles];
    const ticketsBundlesArrCopy = [
      ...copyArr.splice(0, index),
      ...copyArr.splice(index + 1),
    ];
    console.log('state: ', state.ticketsBundles);
    console.log('index: ', index);
    console.log('ticketsBundlesArrCopy: ', ticketsBundlesArrCopy);
    if (ticketsBundlesArrCopy.length === 0) {
      dispatch(setOtherLandingData({ ticketsBundles: ticketsBundlesArrCopy }));
      setState((state) => ({
        ticketsBundles: ticketsBundlesArrCopy,
      }));
      return;
    }
    dispatch(setOtherLandingData({ ticketsBundles: ticketsBundlesArrCopy }));
    setState({
      ticketsBundles: ticketsBundlesArrCopy,
    });
  };

  const handleTickets = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    if (parseInt(e.currentTarget.value) < 1) {
      return;
    }

    const bundlesArray = [...state.ticketsBundles];
    bundlesArray[index] = parseInt(e.currentTarget.value);
    dispatch(setOtherLandingData({ ticketsBundles: bundlesArray }));
    setState({ ...state, ticketsBundles: bundlesArray });
  };
  return (
    <Box>
      <Box display='flex' alignItems='center'>
        <Typography variant='h6'>Status</Typography>
      </Box>
      <>
        {state.ticketsBundles.map((item, i) => {
          return (
            <Box
              display='block'
              className='base-color'
              fontFamily='SF UI Display Light'
            >
              <Box display='flex' alignItems='center'>
                <Box paddingRight='1em' whiteSpace='nowrap'>
                  Tickets
                </Box>
                <Box>
                  <Box marginBottom='0.6em' marginRight='0.6em'>
                    <TextField
                      type='number'
                      label='count'
                      className='discount-field'
                      value={item}
                      onChange={(e) => handleTickets(e, i)}
                      defaultValue={1}
                      required
                    />
                  </Box>
                  {!item && (
                    <Box marginTop='2em' marginLeft='1em'>
                      <div className='common-error'>Required</div>
                    </Box>
                  )}
                  {i !== 0 && item <= state.ticketsBundles[i - 1] && (
                    <Box marginTop='2em' marginLeft='1em'>
                      <div className='common-error'>
                        Should be more than previous value
                      </div>
                    </Box>
                  )}
                  {item > 1000 && (
                    <Box marginTop='2em' marginLeft='1em'>
                      <div className='common-error'>
                        Should be less than 1000
                      </div>
                    </Box>
                  )}
                </Box>
                <CloseIcon
                  className='remove-discount'
                  onClick={handleDeleteItem(i)}
                />
              </Box>
            </Box>
          );
        })}
        {state.ticketsBundles.length < 2 && (
          <Box marginTop='2em'>
            <div className='common-error'>
              Tickets bundles amount shouldn't be less then 2
            </div>
          </Box>
        )}
        <AddCircleIcon onClick={addItem} className='add-discount' />
      </>
    </Box>
  );
};
